import { createBrowserHistory, createHashHistory } from 'history'

// @ts-expect-error window global injected by backend
const portalConfig = window.__PORTAL_CONFIG__ as
  | {
      companyId: string
      portalId: string
      courseId?: string
      brand?: { theme: unknown; font?: unknown }
      branding?: {
        logoUrl?: string | null
        primaryColor?: string | null
        bgColor?: string | null
      }
    }
  | undefined

export const isPortalMode = Boolean(portalConfig)
export const portalContext = portalConfig

const getPortalBasename = (): string => {
  if (!portalConfig) {
    return ''
  }
  const path = window.location.pathname
  const match = path.match(/^(\/contentspace\/public\/portal\/[^/]+)/)
  return match ? match[1] : ''
}

export const portalBasename = getPortalBasename()

export default portalConfig
  ? createBrowserHistory({ basename: portalBasename })
  : createHashHistory()
